import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'


const ScatterChart = ({
    chartLabel,
    chartData = [],
    xField,
    yField,
    colorField,
    xAxisTitle,
    yAxisTitle,
    tooltipFields = [],
    yAxisFormatter,
    purpose,
    yAxisMin,
    yAxisMax,
    yAxisInterval,
}) => {


    const option = {
        legend: {
            top: 5,
            left: "center",
            itemWidth: 14,
            itemHeight: 14,
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
            data: [
                "Urgent",
                "High",
                "Medium",
                "Low",
            ],
        },
        tooltip: {
            trigger: "item",
            formatter(params) {
                const item = params.data;
                let html = "";

                tooltipFields.forEach(field => {
                    let value = item[field?.key];
                    if (
                        value &&
                        (field.key.toLowerCase().includes("date")) 
                        // || value.toString().includes("T"))
                    ) {
                        value = new Date(value).toLocaleDateString("en-GB");
                    }
                    html += `<b>${field?.label}</b> : ${value ?? "-"}<br/>`;
                });

                html += `<b>${xAxisTitle}</b> : ${item?.value[0]}<br/>`;
                html += `<b>${yAxisTitle}</b> : ${item?.value[1]}`;

                if (purpose) {
                    html += `<hr style="margin:6px 0"/>`;
                    html += `<b>Purpose :</b> ${purpose}<br/>`;
                }

                return html;
            },
        },

        grid: {
            left: 70,
            right: 40,
            top: 40,
            bottom: 70,
        },

        xAxis: {
            type: "value",
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 35,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 0,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            }
        },

        yAxis: {
            type: "value",
            min: yAxisMin,
            max: yAxisMax,
            interval: yAxisInterval,
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 55,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisLabel: {
                show: true,
                color: labelColor,
                rotate: 30,
                fontSize: 11,
                formatter(value) {
                    if (yAxisFormatter) {
                        return yAxisFormatter(value);
                    }
                    return value;
                },
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            }
        },

        series: [

            {
                name: "Urgent",
                type: "scatter",
                symbolSize: 16,
                data: chartData
                    .filter(x => x[colorField]?.toLowerCase() === "urgent")
                    .map(item => ({
                        value: [item[xField], item[yField]],
                        ...item,
                    })),
                itemStyle: {
                    color: "#9e0000",
                },
            },

            {
                name: "High",
                type: "scatter",
                symbolSize: 16,
                data: chartData
                    .filter(x => x[colorField]?.toLowerCase() === "high")
                    .map(item => ({
                        value: [item[xField], item[yField]],
                        ...item,
                    })),
                itemStyle: {
                    color: "#EF4444",
                },
            },

            {
                name: "Medium",
                type: "scatter",
                symbolSize: 16,
                data: chartData
                    .filter(x => x[colorField]?.toLowerCase() === "medium")
                    .map(item => ({
                        value: [item[xField], item[yField]],
                        ...item,
                    })),
                itemStyle: {
                    color: "#F59E0B",
                },
            },

            {
                name: "Low",
                type: "scatter",
                symbolSize: 16,
                data: chartData
                    .filter(x => x[colorField]?.toLowerCase() === "low")
                    .map(item => ({
                        value: [item[xField], item[yField]],
                        ...item,
                    })),
                itemStyle: {
                    color: "#22C55E",
                },
            },

        ]

        // series: [
        //     {
        //         type: "scatter",
        //         symbolSize: 16,
        //         data: chartData.map(item => ({
        //             value: [
        //                 item[xField],
        //                 item[yField],
        //             ],
        //             ...item,
        //             itemStyle: {

        //                 color: getColor(item[colorField]),
        //             },
        //         })),
        //     },

        // ],
    };

    return (

        <ChartCard
            title={chartLabel}
            height={450}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />

        </ChartCard>

    );

};

export default ScatterChart;